import config from "appConfig";
import { getLinkForCourseLesson } from "../../../../services/Utils";

import lesson0102 from "../lesson-02/lesson";
import lesson0125 from "../lesson-25/lesson";
const linkLesson0102 = getLinkForCourseLesson("41545ab2-1f99-40ea-8225-21d5e62ab7b0", lesson0102.id);
const linkLesson0125 = getLinkForCourseLesson("41545ab2-1f99-40ea-8225-21d5e62ab7b0", lesson0125.id);

const theory = `<h3 class=sectionHead>Horn equation</h3>
<p>
   Horns are acoustical wave guides which cross section is non uniform. We consider that plane waves propagate in the horn. The two equations of 1D acoustics (see <a href="${linkLesson0102}" target="_blank">Lesson 1.2</a>), have to be rewritten taking into account the variable cross section
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>S</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>
   and the volume velocity
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>U</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>S</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mi>v</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>
   instead of the particle velocity v(x).
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂p</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-punc>,</mo>
                  <mi>t</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-rel>=</mo>
            <mo class=MathClass-bin>−</mo>
            <mfrac>
               <mrow>
                  <msub>
                     <mrow>
                        <mi>ρ</mi>
                     </mrow>
                     <mrow>
                        <mn>0</mn>
                     </mrow>
                  </msub>
               </mrow>
               <mrow>
                  <mi>S</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂U</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-punc>,</mo>
                  <mi>t</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂t</mi>
               </mrow>
            </mfrac>
            </math>
            <td class=eq-no> (1)
            <tr>
            <td>
            <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂U</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-punc>,</mo>
                  <mi>t</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-rel>=</mo>
            <mo class=MathClass-bin>−</mo>
            <mfrac>
               <mrow>
                  <mi>S</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
               <mrow>
                  <msub>
                     <mrow>
                        <mi>ρ</mi>
                     </mrow>
                     <mrow>
                        <mn>0</mn>
                     </mrow>
                  </msub>
                  <msup>
                     <mrow>
                        <mi>c</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂p</mi>
                  <mo class=MathClass-open>(</mo>
                  <mi>x</mi>
                  <mo class=MathClass-punc>,</mo>
                  <mi>t</mi>
                  <mo class=MathClass-close>)</mo>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂t</mi>
               </mrow>
            </mfrac>
         </math>
      <td class=eq-no>(2)
</table>
<p>This leads to the horn equation
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <mn>1</mn>
               </mrow>
               <mrow>
                  <mi>S</mi>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <mi>∂</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mrow>
               <mo fence=true form=prefix>(</mo>
               <mrow>
                  <mi>S</mi>
                  <mfrac>
                     <mrow>
                        <mi mathvariant=italic>∂p</mi>
                     </mrow>
                     <mrow>
                        <mi mathvariant=italic>∂x</mi>
                     </mrow>
                  </mfrac>
               </mrow>
               <mo fence=true form=postfix>)</mo>
            </mrow>
            <mo class=MathClass-rel>=</mo>
            <mfrac>
               <mrow>
                  <mn>1</mn>
               </mrow>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>c</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi>p</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>t</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
         </math>
      <td class=eq-no>(3)
</table>
<p>or else
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi>p</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>x</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mo class=MathClass-bin>+</mo>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>S</mi>
                     </mrow>
                     <mrow>
                        <mi>′</mi>
                     </mrow>
                  </msup>
               </mrow>
               <mrow>
                  <mi>S</mi>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂p</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-rel>=</mo>
            <mfrac>
               <mrow>
                  <mn>1</mn>
               </mrow>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>c</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi>p</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>t</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
         </math>
      <td class=eq-no>(4)
</table>
<p>
   with
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msup>
         <mrow>
            <mi>S</mi>
         </mrow>
         <mrow>
            <mi>′</mi>
         </mrow>
      </msup>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <mstyle class=text>
               <mtext>d</mtext>
            </mstyle>
            <mi>S</mi>
         </mrow>
         <mrow>
            <mstyle class=text>
               <mtext>d</mtext>
            </mstyle>
            <mi>x</mi>
         </mrow>
      </mfrac>
   </math>. Another useful possibility is to use the pair of variables
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mo class=MathClass-open>(</mo>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-punc>,</mo>
      <mi mathvariant=italic>vd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-close>)</mo>
   </math>
   where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>p</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>
   and
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>vd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>v</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>. The two equations of acoustics, then write
<table class=equation>
   <tr>
      <td style="font-size: 11px">
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂pd</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-rel>=</mo>
            <mo class=MathClass-bin>−</mo>
            <msub>
               <mrow>
                  <mi>ρ</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂vd</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂t</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-bin>+</mo>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>d</mi>
                     </mrow>
                     <mrow>
                        <mi>′</mi>
                     </mrow>
                  </msup>
               </mrow>
               <mrow>
                  <mi>d</mi>
               </mrow>
            </mfrac>
            <mi mathvariant=italic>pd</mi>
            </math>
            <td class=eq-no> (5)
            <tr>
            <td>
            <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂vd</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂x</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-rel>=</mo>
            <mo class=MathClass-bin>−</mo>
            <mfrac>
               <mrow>
                  <mn>1</mn>
               </mrow>
               <mrow>
                  <msub>
                     <mrow>
                        <mi>ρ</mi>
                     </mrow>
                     <mrow>
                        <mn>0</mn>
                     </mrow>
                  </msub>
                  <msup>
                     <mrow>
                        <mi>c</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <mi mathvariant=italic>∂pd</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>∂t</mi>
               </mrow>
            </mfrac>
            <mo class=MathClass-bin>−</mo>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>d</mi>
                     </mrow>
                     <mrow>
                        <mi>′</mi>
                     </mrow>
                  </msup>
               </mrow>
               <mrow>
                  <mi>d</mi>
               </mrow>
            </mfrac>
            <mi mathvariant=italic>vd</mi>
         </math>
      <td class=eq-no>(6)
</table>
<p>
   where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msup>
         <mrow>
            <mi>d</mi>
         </mrow>
         <mrow>
            <mi>′</mi>
         </mrow>
      </msup>
   </math>
   is the first derivative of
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>. This leads to
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi mathvariant=italic>pd</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>x</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mo class=MathClass-bin>−</mo>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>d</mi>
                     </mrow>
                     <mrow>
                        <mi class=MathClass-op>″</mi>
                        <mo>⁡</mo>
                     </mrow>
                  </msup>
               </mrow>
               <mrow>
                  <mi>d</mi>
               </mrow>
            </mfrac>
            <mi mathvariant=italic>pd</mi>
            <mo class=MathClass-rel>=</mo>
            <mfrac>
               <mrow>
                  <mn>1</mn>
               </mrow>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>c</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi>p</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>t</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
         </math>
      <td class=eq-no>(7)
</table>
<p>
   where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msup>
         <mrow>
            <mi>d</mi>
         </mrow>
         <mrow>
            <mi class=MathClass-op>″</mi>
            <mo>⁡</mo>
         </mrow>
      </msup>
   </math>
   is the second derivative of
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
   </math>. In the frequency domain this leads to
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <mfrac>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>∂</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mi mathvariant=italic>pd</mi>
               </mrow>
               <mrow>
                  <mi>∂</mi>
                  <msup>
                     <mrow>
                        <mi>x</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
               </mrow>
            </mfrac>
            <mo class=MathClass-bin>+</mo>
            <mrow>
               <mo fence=true form=prefix>(</mo>
               <mrow>
                  <msup>
                     <mrow>
                        <mi>k</mi>
                     </mrow>
                     <mrow>
                        <mn>2</mn>
                     </mrow>
                  </msup>
                  <mo class=MathClass-bin>−</mo>
                  <mfrac>
                     <mrow>
                        <msup>
                           <mrow>
                              <mi>d</mi>
                           </mrow>
                           <mrow>
                              <mi class=MathClass-op>″</mi>
                              <mo>⁡</mo>
                           </mrow>
                        </msup>
                     </mrow>
                     <mrow>
                        <mi>d</mi>
                     </mrow>
                  </mfrac>
               </mrow>
               <mo fence=true form=postfix>)</mo>
            </mrow>
            <mi mathvariant=italic>pd</mi>
            <mo class=MathClass-rel>=</mo>
            <mn>0</mn>
         </math>
      <td class=eq-no>(8)
</table>
<h3 class=sectionHead>Solutions of the wave equation</h3>
<p>
   Considering the last equation there are analytical solutions only if
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mfrac>
         <mrow>
            <msup>
               <mrow>
                  <mi>d</mi>
               </mrow>
               <mrow>
                  <mi class=MathClass-op>″</mi>
                  <mo>⁡</mo>
               </mrow>
            </msup>
         </mrow>
         <mrow>
            <mi>d</mi>
         </mrow>
      </mfrac>
      <mo class=MathClass-rel>=</mo>
      <msup>
         <mrow>
            <mi>m</mi>
         </mrow>
         <mrow>
            <mn>2</mn>
         </mrow>
      </msup>
   </math>
   is a constant. We distinguish three cases according the constant is positive, negative or zero.
<h4 class=subsectionHead>Cone</h4>
<p>
   A cone corresponds to the situation where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mfrac>
         <mrow>
            <msup>
               <mrow>
                  <mi>d</mi>
               </mrow>
               <mrow>
                  <mi class=MathClass-op>″</mi>
                  <mo>⁡</mo>
               </mrow>
            </msup>
         </mrow>
         <mrow>
            <mi>d</mi>
         </mrow>
      </mfrac>
      <mo class=MathClass-rel>=</mo>
      <mn>0</mn>
   </math>. In that case
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-punc>,</mo>
      <mi>ω</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <msup>
         <mrow>
            <mi>e</mi>
         </mrow>
         <mrow>
            <mo class=MathClass-bin>±</mo>
            <mi mathvariant=italic>jkx</mi>
         </mrow>
      </msup>
   </math>
   is solution of the wave equation. Considering that
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mfrac>
         <mrow>
            <mi>d</mi>
            <mo class=MathClass-open>(</mo>
            <mi>x</mi>
            <mo class=MathClass-close>)</mo>
         </mrow>
         <mrow>
            <mi>d</mi>
            <mo class=MathClass-open>(</mo>
            <mn>0</mn>
            <mo class=MathClass-close>)</mo>
         </mrow>
      </mfrac>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <mi>x</mi>
            <mo class=MathClass-bin>+</mo>
            <msub>
               <mrow>
                  <mi>x</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
         </mrow>
         <mrow>
            <msub>
               <mrow>
                  <mi>x</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
         </mrow>
      </mfrac>
   </math>, where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msub>
         <mrow>
            <mi>x</mi>
         </mrow>
         <mrow>
            <mn>0</mn>
         </mrow>
      </msub>
   </math>
   is the distance from the origin
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>x</mi>
      <mo class=MathClass-rel>=</mo>
      <mn>0</mn>
   </math>
   to the apex of the cone, we have
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>p</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>p</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <mfrac>
         <mrow>
            <msub>
               <mrow>
                  <mi>x</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
            <msup>
               <mrow>
                  <mi>e</mi>
               </mrow>
               <mrow>
                  <mo class=MathClass-bin>±</mo>
                  <mi mathvariant=italic>jkx</mi>
               </mrow>
            </msup>
         </mrow>
         <mrow>
            <mi>x</mi>
            <mo class=MathClass-bin>+</mo>
            <msub>
               <mrow>
                  <mi>x</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
         </mrow>
      </mfrac>
      <mo class=MathClass-rel>=</mo>
      <mi>A</mi>
      <mfrac>
         <mrow>
            <msup>
               <mrow>
                  <mi>e</mi>
               </mrow>
               <mrow>
                  <mo class=MathClass-bin>±</mo>
                  <mi mathvariant=italic>jkr</mi>
               </mrow>
            </msup>
         </mrow>
         <mrow>
            <mi>r</mi>
         </mrow>
      </mfrac>
   </math>
   where we set
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>r</mi>
      <mo class=MathClass-rel>=</mo>
      <mi>x</mi>
      <mo class=MathClass-bin>+</mo>
      <msub>
         <mrow>
            <mi>x</mi>
         </mrow>
         <mrow>
            <mn>0</mn>
         </mrow>
      </msub>
   </math>
   and
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>A</mi>
      <mo class=MathClass-rel>=</mo>
      <mi>p</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <msub>
         <mrow>
            <mi>x</mi>
         </mrow>
         <mrow>
            <mn>0</mn>
         </mrow>
      </msub>
      <msup>
         <mrow>
            <mi>e</mi>
         </mrow>
         <mrow>
            <mo class=MathClass-bin>∓</mo>
            <msub>
               <mrow>
                  <mi>x</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
         </mrow>
      </msup>
   </math>. So the solution is that of spherical waves. In fact solution is found in the context of plane wave approximation but it can be shown that spherical waves propagate in a cone.
<h4 class=subsectionHead>Catenoidal horns</h4>
<p>
   This corresponds to the situation where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mfrac>
         <mrow>
            <msup>
               <mrow>
                  <mi>d</mi>
               </mrow>
               <mrow>
                  <mi class=MathClass-op>″</mi>
                  <mo>⁡</mo>
               </mrow>
            </msup>
         </mrow>
         <mrow>
            <mi>d</mi>
         </mrow>
      </mfrac>
      <mo class=MathClass-rel>=</mo>
      <msup>
         <mrow>
            <mi>m</mi>
         </mrow>
         <mrow>
            <mn>2</mn>
         </mrow>
      </msup>
   </math>
   is positive. So the diameter is given by
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <mrow>
         <mo fence=true form=prefix>(</mo>
         <mrow>
            <mi class=qopname>cosh</mi>
            <mo>⁡</mo>
            <mo class=MathClass-open>(</mo>
            <mi mathvariant=italic>mx</mi>
            <mo class=MathClass-close>)</mo>
            <mo class=MathClass-bin>+</mo>
            <mi>T</mi>
            <mi class=qopname>sinh</mi>
            <mo>⁡</mo>
            <mo class=MathClass-open>(</mo>
            <mi mathvariant=italic>mx</mi>
            <mo class=MathClass-close>)</mo>
         </mrow>
         <mo fence=true form=postfix>)</mo>
      </mrow>
   </math>
   or
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi>d</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <mrow>
         <mo fence=true form=prefix>(</mo>
         <mrow>
            <mfrac>
               <mrow>
                  <mn>1</mn>
                  <mo class=MathClass-bin>+</mo>
                  <mi>T</mi>
               </mrow>
               <mrow>
                  <mn>2</mn>
               </mrow>
            </mfrac>
            <msup>
               <mrow>
                  <mi>e</mi>
               </mrow>
               <mrow>
                  <mi mathvariant=italic>mx</mi>
               </mrow>
            </msup>
            <mo class=MathClass-bin>+</mo>
            <mfrac>
               <mrow>
                  <mn>1</mn>
                  <mo class=MathClass-bin>−</mo>
                  <mi>T</mi>
               </mrow>
               <mrow>
                  <mn>2</mn>
               </mrow>
            </mfrac>
            <msup>
               <mrow>
                  <mi>e</mi>
               </mrow>
               <mrow>
                  <mo class=MathClass-bin>−</mo>
                  <mi mathvariant=italic>mx</mi>
               </mrow>
            </msup>
         </mrow>
         <mo fence=true form=postfix>)</mo>
      </mrow>
   </math>, where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>T</mi>
   </math>
   is a constant.
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>T</mi>
      <mo class=MathClass-rel>=</mo>
      <mn>0</mn>
   </math>
   corresponds to the strict catenoidal horn and
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>T</mi>
      <mo class=MathClass-rel>=</mo>
      <mn>1</mn>
   </math>
   to the exponential horn  (see <a href="#" data-img-src=${config.ASSETS_URL}/01/30/theory/figure-1.svg data-img-alt="Figure 1. Shape of various horns with same length and same input and output radius (arbitrary units).">Figure 1</a>).
   <figure class=figure>
<p><img src=${config.ASSETS_URL}/01/30/theory/figure-1.svg alt="Figure 1. Shape of various horns with same length and same input and output radius (arbitrary units)."><figcaption class=caption>Figure 1. Shape of various horns with same length and same input and output radius (arbitrary units).</figcaption></figure>
<p>
   In any case we have
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mo class=MathClass-punc>,</mo>
      <mi>ω</mi>
      <mo class=MathClass-close>)</mo>
      <mo class=MathClass-rel>=</mo>
      <mi mathvariant=italic>pd</mi>
      <mo class=MathClass-open>(</mo>
      <mn>0</mn>
      <mo class=MathClass-close>)</mo>
      <msup>
         <mrow>
            <mi>e</mi>
         </mrow>
         <mrow>
            <mo class=MathClass-bin>±</mo>
            <mi mathvariant=italic>Γx</mi>
         </mrow>
      </msup>
   </math>
   with
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>Γ</mi>
      <mo class=MathClass-rel>=</mo>
      <mi>j</mi>
      <msqrt>
         <mrow>
            <msup>
               <mrow>
                  <mi>k</mi>
               </mrow>
               <mrow>
                  <mn>2</mn>
               </mrow>
            </msup>
            <mo class=MathClass-bin>−</mo>
            <msup>
               <mrow>
                  <mi>m</mi>
               </mrow>
               <mrow>
                  <mn>2</mn>
               </mrow>
            </msup>
         </mrow>
      </msqrt>
   </math>. This propagation constant correspond to a Klein-Gordon case (see <a href="${linkLesson0125}" target="_blank">Lesson 1.25</a>) for which there is no propagation below the cutoff frequency
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msub>
         <mrow>
            <mi>f</mi>
         </mrow>
         <mrow>
            <mi>c</mi>
         </mrow>
      </msub>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <mi mathvariant=italic>mc</mi>
         </mrow>
         <mrow>
            <mn>2</mn>
            <mi>π</mi>
         </mrow>
      </mfrac>
   </math>. So catenoidal horns are characterized by a cutoff frequency. Various catenoidal horns differ by their impedance with a more or less abrupt change between total reflection and total transmission of waves. It can be shown that the input impedance of an infinite catenoidal horn is given by
<table class=equation>
   <tr>
      <td>
         <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
            <msub>
               <mrow>
                  <mi>Z</mi>
               </mrow>
               <mrow>
                  <mi>e</mi>
               </mrow>
            </msub>
            <mo class=MathClass-rel>=</mo>
            <msub>
               <mrow>
                  <mi>Z</mi>
               </mrow>
               <mrow>
                  <mi>c</mi>
               </mrow>
            </msub>
            <mfrac>
               <mrow>
                  <mi>k</mi>
               </mrow>
               <mrow>
                  <msqrt>
                     <mrow>
                        <msup>
                           <mrow>
                              <mi>k</mi>
                           </mrow>
                           <mrow>
                              <mn>2</mn>
                           </mrow>
                        </msup>
                        <mo class=MathClass-bin>−</mo>
                        <msup>
                           <mrow>
                              <mi>m</mi>
                           </mrow>
                           <mrow>
                              <mn>2</mn>
                           </mrow>
                        </msup>
                     </mrow>
                  </msqrt>
                  <mo class=MathClass-bin>+</mo>
                  <mi mathvariant=italic>jmT</mi>
               </mrow>
            </mfrac>
         </math>
      <td class=eq-no>(9)
</table>
<p>
   where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <msub>
         <mrow>
            <mi>Z</mi>
         </mrow>
         <mrow>
            <mi>c</mi>
         </mrow>
      </msub>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <msub>
               <mrow>
                  <mi>ρ</mi>
               </mrow>
               <mrow>
                  <mn>0</mn>
               </mrow>
            </msub>
            <mi>c</mi>
         </mrow>
         <mrow>
            <mi>S</mi>
         </mrow>
      </mfrac>
   </math>
   with
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>S</mi>
   </math>
   the input cross section. The exponential horn has an impedance which tends rapidly to the characteristic impedance, but this is not the horn that radiates the best. The more efficient is for
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>T</mi>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <mn>1</mn>
         </mrow>
         <mrow>
            <msqrt>
               <mrow>
                  <mn>2</mn>
               </mrow>
            </msqrt>
         </mrow>
      </mfrac>
   </math>
   which is geometrically nevertheless very close to the exponential horn. Unlike other horns, the catenoidal horn T = 0, sees its impedance tend to infinity when the frequency approaches the cutoff frequency (see <a href="#" data-img-src=${config.ASSETS_URL}/01/30/theory/figure-2.svg data-img-alt="Figure 2. Input impedance of infinite horns of various shapes and same cut-off frequency except for the cone for which <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>k</mi><msub><mrow><mi>x</mi></mrow><mrow><mn>0</mn></mrow></msub><mo class=MathClass-rel>=</mo><mn>2</mn></math> at the cut-off of the other horns.">Figure 2</a>). A tube extended by such a horn thus behaves rather like a closed tube than an open tube.
   <figure class=figure>
<p><img src=${config.ASSETS_URL}/01/30/theory/figure-2.svg alt="Figure 2. Input impedance of infinite horns of various shapes and same cut-off frequency except for the cone for which <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>k</mi><msub><mrow><mi>x</mi></mrow><mrow><mn>0</mn></mrow></msub><mo class=MathClass-rel>=</mo><mn>2</mn></math> at the cut-off of the other horns."><figcaption class=caption>Figure 2. Input impedance of infinite horns of various shapes and same cut-off frequency except for the cone for which <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>k</mi><msub><mrow><mi>x</mi></mrow><mrow><mn>0</mn></mrow></msub><mo class=MathClass-rel>=</mo><mn>2</mn></math> at the cut-off of the other horns.</figcaption></figure>
<p>
   The cone has no cutoff frequency and impedance slowly approaches the characteristic impedance. In that sense, it cannot really be considered as a horn. For a horn to be truly effective, it is necessary that its length is sufficient. After a look at <a href="#" data-img-src=${config.ASSETS_URL}/01/30/theory/figure-3.svg data-img-alt="Figure 3. Input impedance of exponential horns of various lengths <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>L</mi></math>.">Figure 3</a>, it can be said, as a rule of thumb, that the length of the horn should be at least a quarter of a wavelength at the cutoff frequency.
   <figure class=figure>
<p><img src=${config.ASSETS_URL}/01/30/theory/figure-3.svg alt="Figure 3. Input impedance of exponential horns of various lengths <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>L</mi></math>."><figcaption class=caption>Figure 3. Input impedance of exponential horns of various lengths <math xmlns=http://www.w3.org/1998/Math/MathML display=inline><mi>L</mi></math>.</figcaption></figure>
<h3 class=sectionHead>Note on plane wave approximation</h3>
<p>
   In practice, to calculate the transfer matrix of a horn, simply cut the horn into cone trunks and calculate the product of the matrices for each section. This is the most effective way to treat the problem. Throughout the chapter horns it was assumed that plane waves propagate in the horns. Now the waves propagating in a horn are closer to spherical waves than plane waves. The problem can be solved simply by considering that the length of a portion of the cone is not the length of the cone axis but the length of the side (see <a href="#" data-img-src=${config.ASSETS_URL}/01/30/theory/figure-4.svg data-img-alt="Figure 4. Spherical wave propagation in a cone and plane wave equivalent geometry (notice the origin shift for the equivalent geometry).">Figure 4</a>). If a horn is divided into truncated cones of length
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>Δx</mi>
   </math>, the length
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi mathvariant=italic>ΔL</mi>
      <mo class=MathClass-rel>=</mo>
      <mfrac>
         <mrow>
            <mi mathvariant=italic>Δx</mi>
         </mrow>
         <mrow>
            <mi class=qopname>cos</mi>
            <mo>⁡</mo>
            <mi>𝜃</mi>
         </mrow>
      </mfrac>
   </math>
   where
   <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
      <mi>𝜃</mi>
   </math>
   is the slope (half apex angle of the cone) will be considered. When designing a horn, the actual geometry of a horn will be different from the theoretical one, the actual horn being shorter (see <a href="#" data-img-src=${config.ASSETS_URL}/01/30/theory/figure-5.svg data-img-alt="Figure 5. Exponential horn and its equivalent plane wave geometry (Notice that the equivalent is not an exponential horn).">Figure 5</a>).
   <figure class=figure>
<p><img src=${config.ASSETS_URL}/01/30/theory/figure-4.svg alt="Figure 4. Spherical wave propagation in a cone and plane wave equivalent geometry (notice the origin shift for the equivalent geometry)."><figcaption class=caption>Figure 4. Spherical wave propagation in a cone and plane wave equivalent geometry (notice the origin shift for the equivalent geometry).</figcaption></figure><figure class=figure><p><img src=${config.ASSETS_URL}/01/30/theory/figure-5.svg alt="Figure 5. Exponential horn and its equivalent plane wave geometry (Notice that the equivalent is not an exponential horn)."><figcaption class=caption>Figure 5. Exponential horn and its equivalent plane wave geometry (Notice that the equivalent is not an exponential horn).</figcaption></figure>
<h3>References</h3>
<dl>
  <dt>[1]
  <dd>A. Chaigne and J. Kergomard. Acoustics of Musical Instruments. Springer, New York, 2016.
  <dt>[2]
  <dd>A.D. Pierce. Acoustics: an Introduction to its Physical Principles and Applications. MCGraw-Hill Book Company, Inc., New York, 1981.
  <dt>[3]
  <dd>E. Skudrzyk. The Foundations of Acoustics—Basic Mathematics and Basic Acoustics. Springer–Verlag, 1971.
  <dt>[4]
  <dd>S. Temkin. Elements of Acoustics. Wiley, New York, 1981.
</dl>`;

export default theory;
